import dbConfig from '@upflowy/firebaseconfig';
let app;
export async function initFirebaseApp() {
    if (app)
        return Promise.resolve(app);
    const { initializeApp } = await import('firebase/app');
    app = initializeApp(dbConfig);
    return app;
}
